import { memo } from "react";
import TextInputPermitPDF from "../../inputs/TextInputPermitPDF";

interface StickerIDCardDetailsProps {
    permitDetails: {
        s_StickerNumber: string;
        s_CopyNumber: string;
    };
}

const StickerIDCardDetails = ({
    permitDetails,
}: StickerIDCardDetailsProps) => {
    return (
        <div>
            <div className="bg-green-primary text-center border-b border-black py-0.5">
                <span className="text-[10px] font-bold text-white">
                    Section 1: Sticker/ID Card Details
                </span>
            </div>

            <div className="grid grid-cols-2">
                <TextInputPermitPDF
                    label="Sticker Number:"
                    value={permitDetails?.s_StickerNumber || ""}
                    labelStyles="border-r border-b w-[40%]"
                    valueStyles="border-r border-b w-[60%]"
                />
                <TextInputPermitPDF
                    label="Copy Number:"
                    value={permitDetails?.s_CopyNumber || ""}
                    labelStyles="border-r border-b w-[30%]"
                    valueStyles="border-b w-[70%]"
                />
            </div>
        </div>
    );
};

export default memo(StickerIDCardDetails);
